<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <!-- <b-card>
        <div slot="header">User Profile</div>-->
        <b-form @submit.prevent="save">
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text>Username</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="n_user.n_user_edit.UserName"
                    placeholder="User Name"
                    required
                    autocomplete="off"
                    type="text"
                    id="UserName"
                    @input="$v.UserName.$touch()"
                    v-on:keyup="addDirtyField"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-user appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text>Password</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="n_user.n_user_edit.Password"
                    required
                    autocomplete="off"
                    placeholder="Password"
                    type="password"
                    id="Password"
                    v-on:keyup="addDirtyField"
                    @input="$v.Password.$touch()"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i @click="togglePassword()" class="fa fa-eye appendIcon clickIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text>First Name</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="n_user.n_user_edit.FirstName"
                    placeholder="First Name"
                    required
                    type="text"
                    id="FirstName"
                    autocomplete="off"
                    v-on:keyup="addDirtyField"
                    @input="$v.FirstName.$touch()"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-info-circle appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text>Last Name</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="n_user.n_user_edit.LastName"
                    placeholder="Last Name"
                    required
                    type="text"
                    id="LastName"
                    autocomplete="off"
                    v-on:keyup="addDirtyField"
                    @input="$v.LastName.$touch()"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-info-circle appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text>Email (primary)</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="n_user.n_user_edit.Email1"
                    placeholder="Primary Email Address"
                    required
                    type="email"
                    id="Email1"
                    autocomplete="off"
                    @input="$v.Email1.$touch()"
                    v-on:keyup="addDirtyField"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-envelope appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text>Email (secondary)</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="n_user.n_user_edit.Email2"
                    placeholder="Alternate Email Address"
                    type="email"
                    id="Email2"
                    autocomplete="off"
                    @input="$v.Email2.$touch()"
                    v-on:keyup="addDirtyField"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-envelope appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text>Phone</b-input-group-text>
                  </b-input-group-prepend>

                  <b-form-input
                    v-model="n_user.n_user_edit.Phone1"
                    placeholder="Phone Number"
                    required
                    type="text"
                    id="Phone1"
                    v-mask="'(###) ###-####'"
                    autocomplete="off"
                    v-on:keyup="addDirtyField"
                    @input="$v.$touch()"
                  ></b-form-input>

                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-phone appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text>Mobile</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="n_user.n_user_edit.Phone2"
                    placeholder="Cell Phone Number"
                    type="text"
                    v-mask="'(###) ###-####'"
                    id="Phone2"
                    autocomplete="off"
                    v-on:keyup="addDirtyField"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-phone appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-radio-group
                class="mr-3"
                id="radiosBtn"
                buttons
                button-variant="outline-primary"
                v-model="n_user.n_user_edit.IsSU"
                @change.native="addDirtyFieldRadio"
                name="radiosBtn"
              >
                <b-form-radio class="mx-0 longStandardizedRadioWidth" value="true">Administrator</b-form-radio>
                <b-form-radio class="mx-0 longStandardizedRadioWidth" value="false">Client Care</b-form-radio>
              </b-form-radio-group>
            </b-col>
          </b-row>
          <b-row v-if="false">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  <a v-b-toggle.collapse2 style="cursor:pointer;">
                    <i class="fa fa-caret-down fa-lg mr-2" v-if="seen" @click="toggleVisibility" />
                    <i class="fa fa-caret-up fa-lg mr-2" v-if="!seen" @click="toggleVisibility" />
                    <span v-if="seen" @click="toggleVisibility">More</span>
                    <span v-if="!seen" @click="toggleVisibility">Less</span>
                  </a>
                </div>
                <b-collapse id="collapse2" class="mt-2">
                  <b-tabs>
                    <b-tab active>
                      <template slot="title">
                        <i class="fa fa-id-badge"></i>
                        <span class="ml-1">Employee Information</span>
                      </template>
                      <br />
                      <EmployeeCard />
                    </b-tab>
                    <b-tab>
                      <template slot="title">
                        <i class="fa fa-lock"></i>
                        <span class="ml-1">Permissions</span>
                      </template>
                      <br />
                      <b-list-group>
                        <!-- <ContactRow
                          v-for="contact in client.client_edit.Contacts"
                          :key="contact.ContactID"
                          :contact="contact"
                        />-->
                        <b-list-group-item>Another area to quickly setup a users permissions</b-list-group-item>
                      </b-list-group>
                    </b-tab>
                    <b-tab>
                      <template slot="title">
                        <i class="fa fa-table"></i>
                        <span class="ml-1">Statistics</span>
                      </template>
                      <br />ADD: Billable hours versus hours worked, productivity, etc... discuss
                    </b-tab>
                    <b-tab>
                      <template slot="title">
                        <i class="fa fa-bar-chart"></i>
                        <span class="ml-1">Reports</span>
                      </template>
                      <br />ADD: Employee specific reports TBD
                    </b-tab>
                  </b-tabs>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>

          <div class="form-group form-actions" style="float:right;">
            <b-button class="mr-2 mt-2" size="md" variant="outline-primary" @click="back">
              <!-- <i class="fa fa-close"></i> -->
              Cancel
            </b-button>
            <b-button
              class="mr-0 mt-2"
              size="md"
              variant="primary"
              type="submit"
              :disabled="isClean"
            >
              <i class="fa fa-save"></i>
              Save
            </b-button>
          </div>
          <div class="form-group form-actions" style="float:right;">
            <b-alert
              class="btn mr-4 mt-2"
              :show="dismissCountDown"
              fade
              variant="light"
              :dismissed="dismissCountdown=0"
              @dismiss-count-down="countDownChanged"
            >
              Your information has been saved
              <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
            </b-alert>
            <b-alert
              class="btn mr-4 mt-2"
              :show="dismiss2CountDown"
              fade
              variant="danger"
              :dismissed="dismiss2Countdown=0"
              @dismiss-count-down="countDown2Changed"
            >
              Your information could not be saved. Check all fields carefully.
              <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
            </b-alert>
          </div>
        </b-form>
        <!-- </b-card> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import EmployeeCard from "@/components/cards/EmployeeCard.vue";
import { required, email, helpers } from "vuelidate/lib/validators";
const alpha = helpers.regex("alpha", /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/);
export default {
  name: "UserProfile",
  data() {
    return {
      selected: [], // Must be an array reference!
      dirtyFields: [],
      show: true,
      seen: true,
      isSaving: false,
      isSaved: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      dismiss2Secs: 3,
      dismiss2CountDown: 0,
      showDismissibleAlert: false
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    toggleVisibility() {
      this.seen = !this.seen;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    countDown2Changed(dismiss2CountDown) {
      this.dismiss2CountDown = dismiss2CountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    saveTest() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.$store
          .dispatch("saveOp/Save", {
            _saveOp: {
              Url: "/User/SaveUser/",
              Data: {
                _up: this.$store.state.n_user.n_user_edit,
                _newValues: this.dirtyFields,
                ReturnMap: this.$store.state.n_user.n_user_edit.UserProfileID
              }
            }
          })
          .then(
            (this.dirtyFields = [])((this.dismissCountDown = this.dismissSecs))
          );
      }
    },
    saveTest2() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.$store.state.saveOp.SaveOperation = {
          Url: "/User/SaveUser/",
          Data: {
            _up: this.$store.state.n_user.n_user_edit,
            _newValues: this.dirtyFields,
            ReturnMap: this.$store.state.n_user.n_user_edit.UserProfileID
          }
        };
        this.$store
          .dispatch("saveOp/EmitSave")
          .then(
            (this.dirtyFields = [])((this.dismissCountDown = this.dismissSecs))
          );
      }
    },
    save() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.$store.state.saveOp.localUrl = "/User/SaveUser/";
        this.$store.state.saveOp.localVariableName = "_up";
        this.$store.state.saveOp.localVariableObject = this.$store.state.n_user.n_user_edit;
        this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
        this.$store.state.saveOp.localFieldToSet = "UserProfileID";
        this.$store.state.saveOp.localReturnObject = "SaveUserResult";
        //this.$store.state.n_user.n_user_edit[:UserProfileID];

        this.$store
          .dispatch("saveOp/BuildSaveOperation")
          .then(
            this.$store
              .dispatch("saveOp/EmitSave")
              .then(
                (this.dirtyFields = [])(
                  (this.dismissCountDown = this.dismissSecs)
                )(this.$store.state.saveOp.DestroySaveOperation)
              )
          );

        // this.$store
        //   .dispatch("saveOp/BuildSaveOperation")
        //   .then(this.$store.dispatch.dispatch("saveOp/EmitSave"))
        //   .then(
        //     (this.dirtyFields = [])((this.dismissCountDown = this.dismissSecs))
        //   );
      }
    },
    saveOriginal() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.$store
          .dispatch("n_user/Save", {
            user: this.$store.state.n_user.n_user_edit,
            fields: this.dirtyFields
          })
          .then(
            (this.dirtyFields = [])((this.dismissCountDown = this.dismissSecs))
          );
      }
    },
    greet: function(event) {
    },
    addDirtyField: function(event) {
      if (event.which !== 9 && event.which !== 13) {
        this.dirtyFields = this.dirtyFields.filter(
          dirtyField => dirtyField.FieldName !== event.target.id
        );
        this.dirtyFields.push({
          FieldName: event.target.id,
          FieldValue: event.target.value
        });
        console.log(this.dirtyFields.length);
      }
    },
    togglePassword: function() {
      const passwordField = document.querySelector("#Password");
      if (passwordField.getAttribute("type") === "password") {
        passwordField.setAttribute("type", "text");
      } else {
        passwordField.setAttribute("type", "password");
      }
    },
    addDirtyFieldRadio: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== "IsSU"
      );
      this.dirtyFields.push({
        FieldName: "IsSU",
        FieldValue: event.target.value
      });
      console.log(this.dirtyFields.length);
    }
  },
  computed: {
    ...mapState(["n_user", "saveOp"]),
    ...mapActions("n_user", ["Save"]),
    ...mapActions("saveOp", ["Save", "EmitSave"]),
    isClean() {
      return this.dirtyFields.length === 0;
    }
  },
  components: {
    EmployeeCard
  },
  validations: {
    n_user: {
      n_user_edit: {
        UserName: {
          required
        },
        Password: {
          required
        },
        FirstName: {
          required
        },
        LastName: {
          required
        },
        Email1: {
          required,
          email
        }, //,
        //Email2: {
        //  email
        //}
        Phone1: {
          required
        }
      }
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
</style>
